<template>
  <span>
    <span v-if="candidate.location">{{ candidate.location }}</span>
    <span v-if="candidate.location && candidateYearsOld">, </span>
    <span v-if="candidateYearsOld" class="years-old">
      {{ $tc('yearsOld', candidateYearsOld) }}
    </span>
  </span>
</template>

<script>
import { yearsOld } from '../../date-utils';

export default {
  name: 'CandidateLocationAndYearsOld',
  props: {
    candidate: {
      type: Object,
      required: true,
    },
  },
  computed: {
    candidateYearsOld() {
      if (!this.candidate.birthDate) {
        return null;
      }

      return yearsOld(new Date(this.candidate.birthDate));
    },
  },
};
</script>
<style lang="scss" scoped>
  .years-old {
    white-space: nowrap;
  }
</style>

<i18n locale="en" lang="yaml">
  yearsOld: '0 years | {n} year | {n} years | {n} years'
</i18n>

<i18n locale="ru" lang="yaml">
  yearsOld: '0 лет | {n} год | {n} года | {n} лет'
</i18n>
